var $ = jQuery.noConflict();
const styleSelect = require('styleSelect');

let scrollTop = 0;

let windowWidth = 0,
    isMobile = false;

// infinite scrolling feed variables
let infiniteScrollAjax = false,
    ajaxLoading = false;


// release calendar global variables
let activeFilters = [],
    isFilteringReleases = false;

let articleTop = 0,
    articleBottom = 0,
    articleScrollBool = false;

var _learnq = _learnq || [];

let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

$(document).ready(function(){
  function slickFunction(x) {
    if (x.matches) { // If media query matches
      $('.release-calendar-grid-container').slick({
        dots: false,
      infinite: true,
      slidesToShow: 1,
      autoplay: false,
      prevArrow: jQuery('.slick-prev'),
      nextArrow: jQuery('.slick-next'),
      });
    }
  }

  var x = window.matchMedia("(max-width: 700px)")
  slickFunction(x) // Call listener function at run time
  x.addListener(slickFunction) // Attach listener function on state changes

    //Get in touch select dropdown styling
    $('.ginput_container_select select').addClass('styled-select');

  if ( _sd_userdata.email ) {
    _learnq.push(['identify', {
      // Change the line below to dynamically print the user's email.
      '$email' : _sd_userdata.email
    }]);
  }

  $('.cat-link').each(function() {
    var el = $(this);
    if (el.text() === 'SDEtv') {
       el.css({ 'text-transform' : 'initial' });
    }
  });

  if ( _sd_userdata.search ) {
    _learnq.push(["track", "Searched Site",{
     "SearchTerm": _sd_userdata.search,
     "ReturnedResults":_sd_userdata.search_found
   }]);
  }


  updateWindowSizeMeta();

  $('#mobile-menu-trigger').click(function(e){
    e.preventDefault();
    $('body').toggleClass('mobile-no-scroll');
    $('#mobile-menu').toggleClass('active');
    $(this).toggleClass('active');
  }).keypress(function(){
    $(this).trigger('click');
  });

  $('.mobile-menu-top li.menu-item-has-children').click(function(e){
    if ( ! $(this).hasClass('expanded') ) {
      e.preventDefault();
      $(this).addClass('expanded');
      $(this).find('ul').slideDown();
    }
  });


  if ( $('.infinite-scroll-container').length ) {
    infiniteScrollAjax = true;
  }

  if ( $('#release-month-picker').length ) {
    styleSelect('#release-month-picker');
  }

  if ( $('.styled-select').length ) {
    $('.styled-select').each(function(){
      styleSelect( $(this).get(0) );
    });
  }

  if ( $('.filter-release-section__search').length ) {
    populateFilterCounts();

    $('.filter-release-section__search').on('change', function(){
      $('#release-grids').addClass('loading');
      let data = {
        action: 'do_ajax',
        fn: 'getMonth',
        date: $('#release-month-picker').val()
      };
      if ( $('.filter-release-section__search').val() != '' ) {
        data.search = $('.filter-release-section__search').val();
      }
      $.ajax({
        url: ajaxurl,
        data: data,
        success: function(data){
          if(data !== null){
            data = JSON.parse(data);
            // console.log(data.releases);
            $('#release-grids').html(data.releases);
            applyReleaseFilters();
          }
        },
        complete:function(data){
          // console.log(data);
          $('#release-grids').removeClass('loading');
        },
        error: function(errorThrown) {
          console.log(errorThrown);
        }
      });
    });
  }

  if ( $('.filter-release-section__list .filter-release-section__list__checkbox').length ) {
    $('.filter-release-section__list .filter-release-section__list__item').on('click', function(e){
      if ( isFilteringReleases ) {
        e.preventDefault();
        return false;
      }
    });
    $('.filter-release-section__list .filter-release-section__list__checkbox').on('change', function(e){
      if ( isFilteringReleases ) {
        e.preventDefault();
        return false;
      }
      if ( $(this).is(':checked') ) {
        activeFilters.push($(this).val());
      } else {
        activeFilters.splice( activeFilters.indexOf($(this).val()), 1 );
      }
      applyReleaseFilters();
    });

  }

  if ( $('.release-grid-container') ) {
    applyReleaseFilters();
  }

  if ( $('#release-month-picker').length ) {
    window.onpopstate = function(e){
        if(e.state){
          if ( e.state.hasOwnProperty('date') ) {
            $('#release-month-picker + .style-select .ss-option[data-value="' + e.state.date +'"]').click();
          }
        }
    };

    $('#release-month-picker').on('change', function(){
      const url = updateQueryStringParameter(window.location.href, 'date', $(this).val());
      window.history.pushState({date: $(this).val()}, document.title, url);

      $('#release-grids').addClass('loading');
      let data = {
        action: 'do_ajax',
        fn: 'getMonth',
        date: $('#release-month-picker').val()
      };
      if ( $('.filter-release-section__search').val() != '' ) {
        data.search = $('.filter-release-section__search').val();
      }
      $.ajax({
        url: ajaxurl,
        data: data,
        success: function(data){
          if(data !== null){
            data = JSON.parse(data);
            console.log(data.releases);
            $('#release-grids').html(data.releases);
            populateFilterCounts();
            applyReleaseFilters();
          }
        },
        complete:function(data){
          console.log(data);
          $('#release-grids').removeClass('loading');
        },
        error: function(errorThrown) {
          console.log(errorThrown);
        }
      });
    });
  }

  if ( $('#release-calender-sortby').length ) {

    $('#release-calender-sortby').change(function(e){
      if ( isFilteringReleases ) {
        e.preventDefault();
        return;
      }

      let sortFunc = (a, b) => {
        return 0;
      };
      switch ( $(this).val() ) {
        case 'az':
          sortFunc = (a, b) => {
            const titleA = $(a).find('.release-section__grid-item__album-name').text();
            const titleB = $(b).find('.release-section__grid-item__album-name').text();
            return titleA.localeCompare(titleB);
          };
          break;
        case 'za':
          sortFunc = (a, b) => {
            const titleA = $(a).find('.release-section__grid-item__album-name').text();
            const titleB = $(b).find('.release-section__grid-item__album-name').text();
            return titleB.localeCompare(titleA);
          };
          break;
        case 'asc':
          sortFunc = (a, b) => {
            return $(a).data('price') - $(b).data('price');
          };
          break;
        case 'desc':
          sortFunc = (a, b) => {
            return $(b).data('price') - $(a).data('price');
          };
          break;
        case 'date':
          sortFunc = (a, b) => {
            const dateA = new Date($(a).data('date'));
            const dateB = new Date($(b).data('date'));
            return dateA > dateB;
          };
          break;
        default:
          sortFunc = (a, b) => {
            return 0;
          };
          break;
      }

      $('.release-section-grid').each(function(){
        const items = $(this).find('.release-section__grid-item');
        console.log(items);
        $(this).html('');
        const targetGrid = $(this);
        items.sort(sortFunc).appendTo(targetGrid);
      });

      applyReleaseFilters();
    });
  }

  if ( $('#single-topic-filter').length ) {
    $('#single-topic-filter').on('change', function(){
      $('.infinite-scroll-loader').data('album', $('#single-topic-filter').val());
      $('.infinite-scroll-loader').data('offset', 1);
      $('.infinite-scroll-container').html('');
      loadInfiniteScroll();
    });
  }

  if ( $('.topics-images__carousel').length ) {
    $('.topics-images__carousel').slick({
      fade: true,
      arrows: false,
      dots: false,
      speed: 200
    });

    $('.topics-list__item a').on('mouseenter', function(){
      $('.topics-images__carousel').slick('slickGoTo', $(this).data('for'));
      $('.topics-list__item a').removeClass('active');
      $(this).addClass('active');
    });
  }

  if ( $('.post-type-archive-topic .filter-release-section__list__checkbox').length ) {
    $('.post-type-archive-topic .filter-release-section__list__item').on('click', function(e){
      if ( isFilteringReleases ) {
        e.preventDefault();
        return false;
      }
    });
    $('.post-type-archive-topic .filter-release-section__list__checkbox').on('change', function(){
      if ( isFilteringReleases ) {
        e.preventDefault();
        return false;
      }
      if ( $(this).is(':checked') ) {
        activeFilters.push($(this).val());
      } else {
        activeFilters.splice( activeFilters.indexOf($(this).val()), 1 );
      }

      applyTopicFilters();
    });
  }

  if ( $('#vote').length ) {
    $('.ratings-container a.wp-block-button__link').on('click', function(e) {
      e.preventDefault();
      $('.modal-section').addClass('active');
    });
  }

  if ( $('.dismiss-modal').length ) {
    $('.dismiss-modal').on('click', function(e) {
      $('.modal-section').removeClass('active');
    });
  }

  if ( $('#signup_username').length ) {
    $('#signup_username').on('change', function() {
      console.log($(this).val());
      $('#field_1').val( $(this).val() );
      console.log($('#field_1').val());
    });
  }

  if ( $('.post-scroll-indicator').length ) {
    articleScrollBool = getArticleEndpoints();
    $('main img').on('load', function() {
      articleScrollBool = getArticleEndpoints();
    }).each(function() {
        if ( this.complete ) {
          $(this).trigger('load');
        }
    });
  }

  if ( $('.smooth-scroller').length ) {
    $('.smooth-scroller').click(function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 96;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, ((dist / 1200) * 1000));
    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  if ( $('.edit-profile__field.is-password').length ) {
    $('.edit-profile__field.is-password button').click(function(){
      const input = $(this).prev();
      if ( input.attr('type') == 'password' ) {
        input.attr('type', 'text');
      } else {
        input.attr('type', 'password');
      }
    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  if ( $('.edit-profile__picture-trigger').length ) {
    $('.edit-profile__picture-trigger').click(function(e) {
      e.preventDefault();
      const target = $(this).attr('href');
      console.log(target);
      $(target).addClass('active');
    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  if ( $('.close-modal').length ) {
    $('.close-modal').click(function(){
      $(this).parent().parent().removeClass('active');
    }).keypress(function(){
      $(this).trigger('click');
    }).parent().parent().on('click', function(e){
      if (e.target !== this)
        return;
      $(this).find('.close-modal').trigger('click');
    });
  }

  if ( $('.file-upload-button__input').length ) {
    $('.file-upload-button__input').on('change', function(event){
      var output = $('.file-upload-button img').get(0);
      output.src = URL.createObjectURL(event.target.files[0]);
    });

    let dropArea = $('.file-upload-button__preview').get(0);
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {
        e.preventDefault();
        e.stopPropagation();
        if ( eventName == 'dragenter' || eventName == 'dragover' ) {
          $(dropArea).addClass('dropping');
        } else {
          $(dropArea).removeClass('dropping');
        }
      }, false);

      dropArea.addEventListener('drop', (e) => {
        $('.file-upload-button__input').get(0).files = e.dataTransfer.files;
        $('.file-upload-button__input').trigger('change');
      }, false);
    })
  }

  if ( $('.edit-profile__picture__modal-button').length ) {
    $('.edit-profile__picture__modal-button').on('click', function(e){
      e.preventDefault();
      const action = $(this).attr('id');
      if ( action == 'saveProfilePicture' ) {
        $('.edit-profile__picture__figure img').attr('src', $('.file-upload-button img').attr('src'));
        $('.profile-header__left img').attr('src', $('.file-upload-button img').attr('src'));
        $(this).parent().parent().parent().removeClass('active');
      } else {
        $('.file-upload-button__input').val('');
        $(this).parent().parent().parent().removeClass('active');
      }
    }).on('keypress', function(){
      $(this).trigger('click');
    });
  }

  if ( $('.menu-aux-menu-container a[href="#login"]').length ) {
    $('.menu-aux-menu-container a').on('click', function(e){
      e.preventDefault();
      $('.login-modal__bg').addClass('active');
    }).on('keypress', function(){
      $(this).trigger('click');
    });
  }

  $('body').on('click', '.login-trigger', function(e){
    e.preventDefault();
    $('body').removeClass('mobile-no-scroll');
    $('#mobile-menu').removeClass('active');
    $('#mobile-menu-trigger').removeClass('active');
    $('.login-modal__bg').addClass('active');
  }).on('keypress', '.login-trigger', function(){
    $(this).trigger('click');
  });

  console.log("updating");

  $('body').on('click', '.discussion-trigger', function(e){
    e.preventDefault();
    $('.modal-section').removeClass('active');
    let target = $( $(this).attr('href') ).offset().top - 96;
    // console.log( $(this).attr('href') );
    let dist = Math.abs($(window).scrollTop() - target);
    $([document.documentElement, document.body]).animate({
      scrollTop: target
    }, Math.min(((dist / 1200) * 1000), 2000));
  }).on('keypress', '.discussion-trigger', function(){
    $(this).trigger('click');
  });

  $('.sd-block-tracklist__list-item__toggle').on('click', function(){
    if ( $(this).hasClass('open') ) {
      $(this).next().slideUp(800);
    } else {
      $(this).next().slideDown(800);
    }
    $(this).toggleClass('open');
  }).on('keypress', function(){
    $(this).trigger('click');
  });

  //remove dates on category posts that are duplicates:
  hideDates();

  $('body').on('submit', '.newsletter-form', function(e){
    e.preventDefault();
    const email = $(this).find('input[type="email"]').val();
    if ( validateEmail(email) ) {
      $.ajax({
          url: ajaxurl,
          data: {
              action: 'do_ajax',
              fn: 'newsletter_sub',
              email: email
          },
          success: function(data){
            if(data !== null){
              window.localStorage.setItem('newsletterdone', 'true');
              $('.newsletter-popup').removeClass('active');
              $('.newsletter-confirmation').addClass('active');
              $('.newsletter-confirmation .newsletter-popup__dismiss').on('click', function() {
                  $('newsletter-confirmation').removeClass('active');
              });
              console.log(data);
            }
          },
          complete:function(data){

          },
          error: function(errorThrown) {
            console.log(errorThrown);
          }
      });
    }
  });

  if ( $('form.rating-form').length ) {
    $('form.rating-form').on('submit', function(e){
      e.preventDefault();
      console.log($(this).serializeArray());
      const formResponse = $(this).serializeArray();
      const termID = $(this).data('term');
      const userID = $(this).data('user');

      if ( formResponse.length ) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: 'do_ajax',
                fn: 'register_vote',
                response: formResponse,
                rating_term: termID,
                user: userID
            },
            success: function(data){
              if(data !== null){
                data = JSON.parse(data);
                console.log(data);

                $('.rating-form__footer').slideUp();
                $('.rating-form__inputs input').attr('disabled', 'true');

                if ( data.overall.score ) {
                  $('.sde-rating__norating').fadeOut();
                  $('.sde-rating__overall').fadeIn();
                  $('.sde-rating__overall__num').text( data.overall.score );
                }

                for ( const prop in data.overall.scores ) {
                  const bar = $('.sde-rating__bar.bar-' + prop);
                  // console.log(bar);
                  bar.find('.sde-rating__bar-per span').css('width', data.overall.scores[prop].percent );
                  bar.find('.sde-rating__bar-num').text( data.overall.scores[prop].votes );
                }

                for ( const prop in data.breakdown ) {
                  const cont = $('.sde-rating__area.' + prop);
                  cont.find('.sde-rating__area-num').text( data.breakdown[prop].score );
                  cont.find('.sde-rating__area-count').text( data.breakdown[prop].votes );
                }

                $('.sde-rating__breakdown').removeClass('no-submission');
                $('.rating-form__submitted').slideDown();

                if ( isMobile ) {
                  $('.two-col-modal#vote').animate({
                    scrollTop: 0
                  }, 300);
                }


                setTimeout(function() {
                    $('.modal-section').removeClass('active');
                  }, 10000);
              }
            },
            complete:function(data){

            },
            error: function(errorThrown) {
              console.log(errorThrown);
            }
        });
      }
    });
  }

  if ( $('.newsletter-popup').length ) {
    $('.newsletter-popup__dismiss').on('click', function(){
      $(this).parent().removeClass('active');
      window.localStorage.setItem('newsletterdone', 'true');
    }).on('keypress', function(){
      $(this).trigger('click');
    });

    setTimeout(function() {
      const newsletterSeen = window.localStorage.getItem('newsletterdone');
      if ( newsletterSeen != 'true' ) {
        $('.newsletter-popup').addClass('active');
      }
    }, 3000);
  }

  if ( $('.sde-footnote').length ) {
    $('.sde-footnote').addClass('inactive');

    const internalLinks = $("a[href^='#']");
    internalLinks.each(function(index) {
      console.log($(this).attr('href'));
      const target = $($(this).attr('href'));
      if ( target.hasClass('sde-footnote') ) {
        $(this).wrap('<span class="sde-footnote__container"></span>');
        $(this).addClass('sde-footnote__link');
        target.appendTo($(this).parent());

        $(this).on('click', function(e){
          e.preventDefault();
          $(this).parent().find('.sde-footnote').toggleClass('inactive');
        }).on('keypress', function(){
          $(this).trigger('click');
        });
      }
    });
  }

  if ( $('.related-content__4-column, .related-content__3-column').length ) {
    $('.related-content__4-column, .related-content__3-column').each(function(){
      relatedSlickInit(this);
    });
  }

}); // END DOCUMENT READY

function relatedSlickInit(el) {
  if ( $(el).hasClass('related-content__3-column') ) {
    if ( ! $(el).find('.fauxlinks').length ) {
      const html = $(el).html();
      $(el).html( html + html );
      $(el).children().each(function(index) {
        if ( index > 2 ) {
          console.log($(this));
          $(this).addClass('fauxlinks');
        }
      });
    }
  }

  $(el).slick({
    mobileFirst: true,
    slidesToShow: 3,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="screen-reader-text">Next</span></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  });
}

function applyReleaseFilters() {
  if ( !isFilteringReleases ) {
    isFilteringReleases = true;
    if ( $('.release-calender-sortby-container__label') ) {
      $('.release-calender-sortby-container__label').addClass('filtering');
    }
    console.log(activeFilters);

    let time = 0;
    let count = 0;

    $('.release-section__grid-item').hide();
    $('.release-section__grid-item').addClass('hidden');

    if ( activeFilters.length == 0 ) {
      time += 250;
      $('.release-grid-container').each(function(){
        count = 0;
        $(this).find('.release-section__grid-item').each(function(){
          const thisRef = $(this);
          thisRef.addClass('hidden');
          thisRef.attr('index', count % 4);
          count++;
          setTimeout(function(){
            thisRef.removeClass('hidden');
          }, time);
          time += 50;
        });
        $(this).find('.release-section__grid-item').show();
      });

    } else {
      time += 500;
      $('.release-grid-container').each(function(){
        count = 0;
        $(this).find('.release-section__grid-item').each(function(){
          let shown = false;
          for ( let i = 0; i < activeFilters.length; i++ ) {
            if ( $(this).data('types').includes( activeFilters[i] ) ) {
              shown = true;
            }
          }
          if ( shown ) {
            const thisRef = $(this);
            thisRef.addClass('hidden');
            thisRef.attr('index', count % 4);
            count++;
            thisRef.show();
            setTimeout(function(){
              thisRef.removeClass('hidden');
            }, time);
            time += 50;
          }
        });
      });

    }

    setTimeout(function(){
      isFilteringReleases = false;
      if ( $('.release-calender-sortby-container__label') ) {
        $('.release-calender-sortby-container__label').removeClass('filtering');
      }
    }, time);


  }
}

function applyTopicFilters() {
  if ( !isFilteringReleases ) {
    isFilteringReleases = true;
    let time = 0;
    let count = 0;

    $('.topics-list__item').hide();
    $('.topics-list__item').addClass('hidden');

    if ( activeFilters.length == 0 ) {
      time += 50;
      $('.topics-list__item').each(function(){
        const thisRef = $(this);
        thisRef.addClass('hidden');
        thisRef.attr('index', count % 4);
        count++;
        setTimeout(function(){
          thisRef.removeClass('hidden');
        }, time);
        time += 50;
      });
      $('.topics-list__item').show();
    } else {
      time += 50;
      $('.topics-list__item').each(function(){
        let shown = false;
        for ( let i = 0; i < activeFilters.length; i++ ) {
          if ( $(this).data('terms').includes( activeFilters[i] ) ) {
            shown = true;
          }
        }
        if ( shown ) {
          const thisRef = $(this);
          thisRef.addClass('hidden');
          thisRef.attr('index', count % 4);
          count++;
          thisRef.show();
          setTimeout(function(){
            thisRef.removeClass('hidden');
          }, time);
          time += 50;
        }
      });
    }

    setTimeout(function(){
      isFilteringReleases = false;
    }, time);
  }
}

function hideDates(){
  var t = '';
  $(".archive-article-wrapper__date").each(function(i,v){
    console.log($("time",v).text());
    if(t == $("time",v).text()){
      $(v).addClass("screen-reader-text");
    }
    t = $("time",v).text();
  });
}


function loadInfiniteScroll() {
  ajaxLoading = true;

  let fn = 'loadMore';
  if ( $('.infinite-scroll-loader').hasClass('single') ) {
    fn = 'loadMoreSingle';
  } else if ( $('.infinite-scroll-loader').hasClass('video') ) {
    fn = 'loadMoreVideo';
  } else if ( $('.infinite-scroll-loader').hasClass('topic') ) {
    fn = 'loadMoreTopics';
  } else if ( $('.infinite-scroll-loader').hasClass('search') ) {
    fn = 'loadMoreSearch';
  } else if ( $('.infinite-scroll-loader').hasClass('comments') ) {
    fn = 'loadMoreComments';
  }

  $(".loading").fadeIn();
  $.ajax({
      url: ajaxurl,
      data: {
          action: 'do_ajax',
          fn: fn,
          args: {},
          date: $('.infinite-scroll-loader').data('date'),
          slug: $('.infinite-scroll-loader').data('slug'),
          offset: $('.infinite-scroll-loader').data('offset'),
          tax: $('.infinite-scroll-loader').data('tax'),
          postsper: $('.infinite-scroll-loader').data('postsper'),
          layout: $('.infinite-scroll-loader').data('layout'),
          tags: $('.infinite-scroll-loader').data('tags'),
          album: $('.infinite-scroll-loader').data('album'),
          search: $('.infinite-scroll-loader').data('search'),
          email: $('.infinite-scroll-loader').data('email'),
          mentions: $('.infinite-scroll-loader').data('mentions')
      },
      success: function(data){
        if(data !== null){
          data = JSON.parse(data);
          //console.log(data);
          //console.log(data.posts);
          $('.infinite-scroll-container').append(data.posts);
          $('.infinite-scroll-loader').data('date', data.date);
          $('.infinite-scroll-loader').data('offset', data.offset);
          if ( data.posts == '' ) {
            ajaxLoading = true;
          } else {
            ajaxLoading = false;
          }

        }
      },
      complete:function(data){
        console.log(data);
        console.log("hello");
          hideDates();
          $(".loading").fadeOut();

      },
      error: function(errorThrown) {
        console.log(errorThrown);
        ajaxLoading = false;
      }
  });
}

$(window).scroll(function(){
  scrollTop = $(this).scrollTop();

  if ( scrollTop > 180 ) {
    $('header#masthead').addClass('scrolled');
    $('header#masthead').removeClass('scrolled-back');
  } else {
    $('header#masthead').removeClass('scrolled');
    $('header#masthead').addClass('scrolled-back');
  }

  if ( infiniteScrollAjax && scrollTop >= ($('body').height() - ($(window).height() * 1.5)) && ajaxLoading == false ) {
    loadInfiniteScroll();
  }

  if ( articleScrollBool ) {
    const per = Math.max(Math.min(((scrollTop - articleTop) / (articleBottom - articleTop)) * 100, 100), 0);
    $('.post-scroll-indicator').css('width', per + '%');
  }
});

$(window).resize(function(){
  let preUpdate = isMobile;
  updateWindowSizeMeta();
  if ( preUpdate == false && isMobile == true ) {
    if ( $('.related-content__4-column, .related-content__3-column') ) {
      $('.related-content__4-column, .related-content__3-column').each(function(){
        relatedSlickInit(this);
      });
    }
  }
  if ( $('.post-scroll-indicator').length ) {
    articleScrollBool = getArticleEndpoints();
  }
});

function updateWindowSizeMeta() {
  windowWidth = $(window).width();
  isMobile = windowWidth < 767 ? true : false;
}

function populateFilterCounts() {
  const counts = {};
  if ( $('.release-section-grid').length ) {
    $('.release-section-grid').each(function(){
      const data = $(this).data('counts');
      for ( const property in data ) {
        console.log(property, ':', data[property]);
        if ( !counts.hasOwnProperty(property) ) {
          counts[property] = parseInt(data[property]);
        } else {
          counts[property] += parseInt(data[property]);
        }
      }
    });
  }

  $('.filter-release-section__list__checkbox').each(function(){
    const key = $(this).attr('value');
    let val = 0;
    if ( counts.hasOwnProperty(key) ) {
      val = counts[key];
    }

    if ( val == 0 ) {
      $(this).attr('disabled', true);
      $(this).prop( "checked", false );
    } else {
      $(this).removeAttr("disabled");
    }
    $(this).next().find('.topics-span__count').text(val);
  });
}

function getArticleEndpoints() {
  if ( $('header.single-header').length && $('nav.bottom-nav').length ) {
    articleTop = $('header.single-header').offset().top;
    articleBottom = $('nav.bottom-nav').offset().top;

    return true;
  }

  return false;
}

function validateEmail(email) {
 if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
   return true;
 }
 return false;
}

$('.wpd-vote-up').append('<div class="thumbs-up></div>');

$('.topics-browse__down-chevron').click(function() {
  console.log('works');
});

//DROP CAP STYLING

$('p.has-drop-cap').html(function (i, html)
{return html.replace(/^[^a-zA-Z]*([a-zA-Z])/g, '<span class="drop-cap">$1</span>');
});

//poll submit btn change text copy

$('.wp-block-poll .gform_wrapper .gform_footer input[type=submit]').text('vote');

$('table').wrap('<div class="price-comp-widget-container />');

  $('.wpd-comment-share').click(function() {
    $(this).children('.wpd-tooltip-content').toggleClass('show-comment-meta');
});

$('.wpdiscuz-vote-sort-up[data-sorting="by_vote"]').text('Most Liked');

$('.wpd-hidden').click(function() {
  $(this).children('.wpd-tools-actions').toggleClass('show-tools-actions');
});

$('.registered p').html('<p style="margin: 1.2rem 0;">Thank you! You have now successfully created your mySDE account.</p> <p style="margin: 1.2rem 0;">To activate the account, follow the instructions in the email we have just sent you.</p> <p style="margin: 1.2rem 0;">(If you can’t find the email, don’t forget to check your spam folder)</p>');

$('.sde-deal__main').attr('target', '_blank');

$('.blue-overlay-pauls-picks').hover(function() {
    $('.pauls-picks-container .widget-text-box h4').addClass('pauls-picks-blue-text');
}, function() {
      $('.pauls-picks-container .widget-text-box h4').removeClass('pauls-picks-blue-text');
});

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
  if( value === undefined ) {
  	if (uri.match(re)) {
		return uri.replace(re, '$1$2');
	} else {
		return uri;
	}
  } else {
  	if (uri.match(re)) {
  		return uri.replace(re, '$1' + key + "=" + value + '$2');
	} else {
    var hash =  '';
    if( uri.indexOf('#') !== -1 ){
        hash = uri.replace(/.*#/, '#');
        uri = uri.replace(/#.*/, '');
    }
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    return uri + separator + key + "=" + value + hash;
  }
  }
}

//unapproved comments
